import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AppService, CartService, Host, MenuItem} from "../../../../common";
import {AddToCartButton} from "./add-to-cart-button";

@Component({
  selector: 'flat-menu-item',
  standalone: false,
  template: `
    <div class="card is-clickable mb-3 item-entry" (click)="onClickItem($event)">
      <div class="overlay-wrap">
        <img class="card-img" [src]="item.image" *ngIf="item.image" alt="{{ item.name }}">
        <div [class.card-img-overlay]="item.image" [class.card-body]="!item.image">
          <div class="card-title row mb-0 align-items-center">
            <div class="col">
              <div class="row">
                <h2 class="col h5 mb-1">{{ item.name }}</h2>
              </div>
              <div class="row" *ngIf="!item.hasVariants()">
                <div class="col">{{ item.quantity }}</div>
                <div class="col-auto"><b>{{ item.price|currency:host }}</b></div>
              </div>
              <div class="row" *ngIf="item.hasVariants()">
                <div class="col" i18n>Multiple variants</div>
                <div class="col-auto"><span i18n>from</span>&nbsp;<b>{{ item.variants[0].price|currency:host }}</b>
                </div>
              </div>
            </div>
            <div class="col-auto" *ngIf="ordersEnabled">
              <add-to-cart [itemId]="item.id.toString()" [showLabel]="false" *ngIf="!mustExpand"
                           (clickAnimationDone)="onClickDone()"></add-to-cart>
              <button type="button" class="btn btn-warning order-button"
                     title="Add to cart" i18n-title *ngIf="mustExpand">
                <i id="cart-src{{ item.id }}" class="fa fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class FlatMenuItemComponent implements OnInit {

  @Input() host: Host;
  @Input() item: MenuItem;
  @Output() requestExpand = new EventEmitter<MenuItem>();
  @ViewChild(AddToCartButton)
  private addToCartButton: AddToCartButton;

  canExpand: boolean;
  mustExpand: boolean;
  ordersEnabled: boolean;

  constructor(
    private appService: AppService,
    private cartService: CartService,
  ) { }

  ngOnInit(): void {
    this.ordersEnabled = this.appService.getOrdersEnabled();
    this.mustExpand = this.item.hasVariants() || this.item.hasOptions() || this.item.hasChoices()
    this.canExpand = (this.item.text.length > 0) || this.item.hasFootnotes();
  }

  onClickItem($event) {
    if (this.canExpand || this.mustExpand) {
      this.requestExpand.emit(this.item);
    }
    $event.stopPropagation();
  }

  onClickDone() {
    this.appService.trackEvent('action', 'addToCart');
    this.cartService.addToCart({
      item: this.item,
      count: 1,
      variant_id: null,
      option_ids: [],
      choices: {}
    });
  }
}
